module.exports = __webpack_public_path__ + "static/media/flammini.6c5a62cb.jpg";